import { Button } from '@repo/shadcn';
import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';

import { PaymentStatusBadge } from '@/components/ui/badge';
import { Route } from '@/constants';

export const dueOrdersColumns: ColumnDef<any>[] = [
    {
        accessorKey: 'invoice_number',
        header: () => {
            return <span>Invoice No.</span>;
        },
        cell: ({ row }) => (
            <Link to={`${Route.SALES}/${row.original.id}`}>
                <Button
                    type="button"
                    variant={'link'}
                    size={'default'}
                    className="p-0 text-black"
                >
                    {row.getValue('invoice_number')}
                </Button>
            </Link>
        ),
    },

    {
        accessorKey: 'total_price',
        header: () => {
            return (
                <div className="flex justify-center">
                    <span className="">Total Price</span>
                </div>
            );
        },
        cell: ({ row }) => {
            return (
                <div className="text-center">
                    {row.original.payment?.total_price
                        ? row.original.payment?.total_price
                        : 'N/A'}
                </div>
            );
        },
    },

    {
        accessorKey: 'total_paid',
        header: () => {
            return (
                <div className="flex justify-center">
                    <span className="">Total Paid</span>
                </div>
            );
        },
        cell: ({ row }) => {
            return (
                <div className="text-center">
                    {row.original.payment?.total_paid
                        ? row.original.payment?.total_paid
                        : 'N/A'}
                </div>
            );
        },
    },

    // {
    //   accessorKey: 'total_due',
    //   header: () => {
    //     return (
    //       <div className="flex justify-center">
    //         <span className="">Total Due</span>
    //       </div>
    //     );
    //   },
    //   cell: ({ row }) => {
    //     return (
    //       <div className="text-center">
    //         {row.original.payment?.total_due
    //           ? row.original.payment?.total_due
    //           : 'N/A'}
    //       </div>
    //     );
    //   },
    // },

    {
        accessorKey: 'payment_status',
        header: () => {
            return (
                <div className="flex justify-center">
                    <span className="">Payment Status</span>
                </div>
            );
        },

        cell: ({ row }) => {
            return (
                <div className="text-center">
                    {row.original.payment?.status ? (
                        <PaymentStatusBadge
                            status={row.original.payment?.status}
                        />
                    ) : (
                        'N/A'
                    )}
                </div>
            );
        },
    },
];
